import { memo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Typography } from 'antd';

interface ResetPasswordCardProps {
    resetPasswordFormSlot: ReactNode;
}

export const ResetPasswordCard = memo((props: ResetPasswordCardProps) => {
    const { resetPasswordFormSlot } = props;

    const { t } = useTranslation('auth');

    return (
        <Card
            className="auth-card"
            title={
                <Typography.Title level={2}>
                    {t('resetPasswordCardTitle')}
                </Typography.Title>
            }
        >
            {resetPasswordFormSlot}
        </Card>
    );
});

ResetPasswordCard.displayName = 'ForgotPasswordCard';
